import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_2 = {
  key: 2,
  class: "row"
}
const _hoisted_3 = {
  key: 0,
  class: "col-xs-12 col-sm-12"
}
const _hoisted_4 = {
  key: 1,
  class: "col-xs-12 col-sm-12"
}
const _hoisted_5 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_6 = {
  key: 0,
  class: "configprop"
}
const _hoisted_7 = { class: "col-sm-12" }
const _hoisted_8 = {
  key: 2,
  class: "col-xs-12 col-sm-12 form-horizontal"
}
const _hoisted_9 = {
  key: 0,
  class: "form-group"
}
const _hoisted_10 = { class: "col-sm-12" }
const _hoisted_11 = ["value", "data-hidden-field-identity", "data-testid"]
const _hoisted_12 = ["data-prop-name", "data-testid"]
const _hoisted_13 = ["open", "data-testid"]
const _hoisted_14 = { class: "row" }
const _hoisted_15 = ["value", "data-hidden-field-identity", "data-testid"]
const _hoisted_16 = ["data-prop-name", "data-testid"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pluginInfo = _resolveComponent("pluginInfo")!
  const _component_plugin_prop_view = _resolveComponent("plugin-prop-view")!
  const _component_plugin_prop_edit = _resolveComponent("plugin-prop-edit")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.error && _ctx.isTitleMode)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    (_ctx.isTitleMode && !_ctx.error)
      ? (_openBlock(), _createBlock(_component_pluginInfo, {
          key: 1,
          "show-title": _ctx.inputShowTitle,
          "show-icon": _ctx.inputShowIcon,
          "show-description": _ctx.inputShowDescription,
          detail: _ctx.detail
        }, {
          titleprefix: _withCtx(() => [
            _renderSlot(_ctx.$slots, "iconSuffix", {}, undefined, true)
          ]),
          suffix: _withCtx(() => [
            _renderSlot(_ctx.$slots, "titleSuffix", {}, undefined, true)
          ]),
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "titlePrefix", {}, undefined, true)
          ]),
          _: 3
        }, 8, ["show-title", "show-icon", "show-description", "detail"]))
      : _createCommentVNode("", true),
    (!_ctx.isTitleMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.inputShowIcon || _ctx.inputShowTitle || _ctx.inputShowDescription)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "header", {
                  header: {
            inputShowTitle: _ctx.inputShowTitle,
            inputShowIcon: _ctx.inputShowIcon,
            inputShowDescription: _ctx.inputShowDescription,
            detail: _ctx.detail,
          }
                }, () => [
                  _createElementVNode("p", null, [
                    _createVNode(_component_pluginInfo, {
                      "show-title": _ctx.inputShowTitle,
                      "show-icon": _ctx.inputShowIcon,
                      "show-description": _ctx.inputShowDescription,
                      detail: _ctx.detail
                    }, {
                      titleprefix: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "iconSuffix", {}, undefined, true)
                      ]),
                      suffix: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "titleSuffix", {}, undefined, true)
                      ]),
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "titlePrefix", {}, undefined, true)
                      ]),
                      _: 3
                    }, 8, ["show-title", "show-icon", "show-description", "detail"])
                  ])
                ], true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isShowMode && _ctx.config)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.validation && !_ctx.validation.valid)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.validationWarningText), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props, (prop) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: prop.name
                  }, [
                    (
              (prop.type === 'Boolean' || _ctx.config[prop.name]) &&
              _ctx.isPropInScope(prop) &&
              !_ctx.isPropHidden(prop)
            )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                          _createVNode(_component_plugin_prop_view, {
                            prop: prop,
                            value: _ctx.config[prop.name],
                            "allow-copy": _ctx.allowCopy
                          }, null, 8, ["prop", "value", "allow-copy"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                _createElementVNode("div", _hoisted_7, [
                  _renderSlot(_ctx.$slots, "extraProperties", {}, undefined, true)
                ])
              ]))
            : (_ctx.isShowConfigForm && _ctx.inputLoaded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_ctx.$slots.extraProperties)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _renderSlot(_ctx.$slots, "extraProperties", {}, undefined, true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedProperties, (group, gindex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: group.name
                    }, [
                      (!group.name)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(group.props, (prop, pindex) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: 'g_' + gindex + '/' + prop.name
                            }, [
                              (_ctx.isPropHidden(prop))
                                ? (_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    type: "hidden",
                                    value: _ctx.inputValues[prop.name],
                                    "data-hidden-field-identity": prop.options['hidden_identity'],
                                    "data-testid": `prop-hidden-${prop.name}`,
                                    class: "_config_prop_display_hidden"
                                  }, null, 8, _hoisted_11))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(
                'form-group ' +
                (prop.required ? 'required' : '') +
                (_ctx.validation && _ctx.validation.errors[prop.name] ? ' has-error' : '')
              ),
                                    "data-prop-name": prop.name,
                                    "data-testid": `prop-field-${prop.name}`
                                  }, [
                                    _createVNode(_component_plugin_prop_edit, {
                                      modelValue: _ctx.inputValues[prop.name],
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.inputValues[prop.name]) = $event),
                                      prop: prop,
                                      "event-bus": _ctx.eventBus,
                                      "input-values": _ctx.inputValues,
                                      "use-runner-selector": _ctx.useRunnerSelector,
                                      "context-autocomplete": _ctx.inputContextAutocomplete,
                                      validation: _ctx.validation,
                                      rkey: 'g_' + gindex + '_' + _ctx.rkey,
                                      "read-only": _ctx.readOnly,
                                      pindex: pindex,
                                      "selector-data": _ctx.propsComputedSelectorData,
                                      "autocomplete-callback": _ctx.autocompleteCallback,
                                      "step-type": _ctx.serviceName,
                                      "plugin-type": _ctx.modelValue.type,
                                      "extra-autocomplete-vars": _ctx.extraAutocompleteVars,
                                      onPluginPropsMounted: _ctx.notifyHandleAutoComplete
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "prop", "event-bus", "input-values", "use-runner-selector", "context-autocomplete", "validation", "rkey", "read-only", "pindex", "selector-data", "autocomplete-callback", "step-type", "plugin-type", "extra-autocomplete-vars", "onPluginPropsMounted"])
                                  ], 10, _hoisted_12))
                            ]))
                          }), 128))
                        : _createCommentVNode("", true),
                      (group.name)
                        ? (_openBlock(), _createElementBlock("details", {
                            key: 1,
                            open: !group.secondary,
                            class: "more-info details-reset",
                            "data-testid": `prop-section-${group.name}`
                          }, [
                            _createElementVNode("summary", null, [
                              _createElementVNode("span", _hoisted_14, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(_ctx.groupCss)
                                }, [
                                  _createTextVNode(_toDisplayString(group.name !== "-" ? group.name : "More") + " ", 1),
                                  _cache[1] || (_cache[1] = _createElementVNode("i", { class: "more-indicator-verbiage more-info-icon glyphicon glyphicon-chevron-right" }, null, -1)),
                                  _cache[2] || (_cache[2] = _createElementVNode("i", { class: "less-indicator-verbiage more-info-icon glyphicon glyphicon-chevron-down" }, null, -1))
                                ], 2)
                              ])
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.props, (prop, pindex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: 'g_' + gindex + '/' + prop.name
                              }, [
                                (_ctx.isPropHidden(prop))
                                  ? (_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      type: "hidden",
                                      value: _ctx.inputValues[prop.name],
                                      "data-hidden-field-identity": prop.options['hidden_identity'],
                                      "data-testid": `prop-hidden-${prop.name}`,
                                      class: "_config_prop_display_hidden"
                                    }, null, 8, _hoisted_15))
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: _normalizeClass(
                  'form-group ' +
                  (prop.required ? 'required' : '') +
                  (_ctx.validation && _ctx.validation.errors[prop.name]
                    ? ' has-error'
                    : '')
                ),
                                      "data-prop-name": prop.name,
                                      "data-testid": `prop-field-${prop.name}`
                                    }, [
                                      _createVNode(_component_plugin_prop_edit, {
                                        modelValue: _ctx.inputValues[prop.name],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.inputValues[prop.name]) = $event),
                                        prop: prop,
                                        "use-runner-selector": _ctx.useRunnerSelector,
                                        "input-values": _ctx.inputValues,
                                        "is-storage-prop": _ctx.isStorageProperty(prop),
                                        validation: _ctx.validation,
                                        "read-only": _ctx.readOnly,
                                        "event-bus": _ctx.eventBus,
                                        rkey: 'g_' + gindex + '_' + _ctx.rkey,
                                        pindex: pindex,
                                        "selector-data": _ctx.propsComputedSelectorData,
                                        "step-type": _ctx.serviceName,
                                        "plugin-type": _ctx.modelValue.type,
                                        "autocomplete-callback": _ctx.autocompleteCallback,
                                        "extra-autocomplete-vars": _ctx.extraAutocompleteVars
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "prop", "use-runner-selector", "input-values", "is-storage-prop", "validation", "read-only", "event-bus", "rkey", "pindex", "selector-data", "step-type", "plugin-type", "autocomplete-callback", "extra-autocomplete-vars"])
                                    ], 10, _hoisted_16))
                              ]))
                            }), 128))
                          ], 8, _hoisted_13))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "extra", {}, undefined, true)
  ]))
}